(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["first-xi-booking"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.fx-booking form').forEach(form=>{
const date=form.querySelector('input[type="date"]'), start=form.querySelector('input[type="time"][name="contact[Start time]"]'), end=form.querySelector('input[type="time"][name="contact[End time]"]');
if(date){const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());const part=t=>parts.find(p=>p.type===t).value;date.min=part('year')+'-'+part('month')+'-'+part('day');}
if(start&&end){const check=()=>end.setCustomValidity(end.value&&start.value&&end.value<=start.value?'Please choose an end time after the start time.':'');start.addEventListener('change',check);end.addEventListener('change',check);form.addEventListener('submit',check);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-xi-bundle-builder"] && !Shopify.designMode) return;
  try {
    
function initFirstXiBundles(root){root.querySelectorAll('[data-bundle]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';section.querySelectorAll('[data-coffee]').forEach(select=>{function update(){const chosen=select.selectedOptions[0];const image=select.closest('fieldset').querySelector('[data-label-image]');image.src=chosen.dataset.image;image.alt=chosen.value+' — medium-roast label artwork';}select.addEventListener('change',update);update();});});}initFirstXiBundles(document);document.addEventListener('shopify:section:load',event=>initFirstXiBundles(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-xi-coffee-hub"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('first-xi-brew-guide')){customElements.define('first-xi-brew-guide',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;this.querySelector('[data-calculator]').hidden=false;this.addEventListener('input',()=>this.update());this.update()}update(){const water=this.querySelector('[data-water]');const dose=this.querySelector('[data-dose]');if(!water.validity.valid||!water.value){dose.textContent='—';return}const ratio=Number(this.querySelector('[data-ratio]').value);dose.textContent=(Number(water.value)/ratio).toFixed(1).replace(/\.0$/,'')}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-xi-fundraiser-goal"] && !Shopify.designMode) return;
  try {
    
function firstXiFundraiserBags(goal){return Math.ceil(goal/6);}
function firstXiInitGoal(root){root.querySelectorAll('.fx-goal').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const input=section.querySelector('input');const result=section.querySelector('[role="status"]');input.addEventListener('input',()=>{const goal=input.valueAsNumber;result.textContent=Number.isFinite(goal)&&goal>=1&&goal<=1000000?result.dataset.template.replace('[bags]',firstXiFundraiserBags(goal).toLocaleString()):result.dataset.invalid;});});}
firstXiInitGoal(document);document.addEventListener('shopify:section:load',event=>firstXiInitGoal(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-xi-roast-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('first-xi-roast-finder')){customElements.define('first-xi-roast-finder',class extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;this.querySelector('[data-controls]').hidden=false;this.querySelector('[data-result-heading]').hidden=false;this.addEventListener('change',()=>this.update());this.update()}update(){const flavor=this.querySelector('input:checked').value;const method=this.querySelector('[data-method]').value;const match=method==='espresso'?'espresso':flavor;this.querySelectorAll('[data-coffee]').forEach(card=>{card.hidden=card.dataset.coffee!==match})}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-xi-roast-quiz"] && !Shopify.designMode) return;
  try {
    
function firstXiRoastMatch(taste,method,caffeine){if(caffeine==='decaf')return 'decaf';if(method==='espresso')return 'espresso';if(taste==='bright')return 'honduras';if(taste==='nutty')return 'playmaker';if(taste==='bold')return 'espresso';return 'costa';}
function firstXiInitQuiz(root){root.querySelectorAll('.fx-quiz').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';section.querySelector('form').addEventListener('submit',event=>{event.preventDefault();const values=new FormData(event.currentTarget);const match=firstXiRoastMatch(values.get('taste'),values.get('method'),values.get('caffeine'));const cards=Array.from(section.querySelectorAll('[data-match]'));const chosen=cards.find(card=>card.dataset.match===match)||cards.find(card=>card.dataset.match==='costa');cards.forEach(card=>card.hidden=card!==chosen);});});}
firstXiInitQuiz(document);document.addEventListener('shopify:section:load',event=>firstXiInitQuiz(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-xi-shopping-tools"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('xi-shopping-tools')){
class XiShoppingTools extends HTMLElement{
connectedCallback(){queueMicrotask(()=>this.initialize())}
initialize(){
const root=this;const select=root.querySelector('[data-xi-partner]');const search=root.querySelector('[data-xi-search]');const chosen=root.querySelector('[data-xi-chosen]');const link=root.querySelector('[data-xi-partner-link]');const strings=JSON.parse(root.querySelector('[data-xi-strings]').textContent);const options=Array.from(select.options).slice(1).map(o=>({name:o.text,value:o.value}));
const storageGet=()=>{try{return localStorage.getItem('first-xi-partner-url')||''}catch{return ''}};
let selected=storageGet();const display=()=>{const value=selected;const partner=options.find(o=>o.value===value);select.value=partner?value:'';chosen.textContent=partner?partner.name:'';link.hidden=!partner;if(partner)link.href=partner.value};
display();
select.addEventListener('change',()=>{selected=select.value;try{if(select.value)localStorage.setItem('first-xi-partner-url',select.value);else localStorage.removeItem('first-xi-partner-url')}catch{}display()});
root.querySelector('[data-xi-clear]').addEventListener('click',()=>{selected='';try{localStorage.removeItem('first-xi-partner-url')}catch{}search.value='';filter();display()});
const filter=()=>{const term=search.value.trim().toLowerCase();const matches=options.filter(o=>o.name.toLowerCase().includes(term));select.replaceChildren(new Option(select.options[0].text,''),...matches.map(o=>new Option(o.name,o.value)));select.value=selected;root.querySelector('[data-xi-search-result]').textContent=matches.length?'':strings.no_matches;};search.addEventListener('input',filter);
this.displayListener=()=>{selected=storageGet();display()};window.addEventListener('storage',this.displayListener);
const shipping=root.querySelector('[data-xi-shipping]');if(!shipping)return;
const show=(total,currency,physical)=>{const message=shipping.querySelector('[data-xi-shipping-message]');const progress=shipping.querySelector('progress');progress.hidden=currency!=='USD'||!physical;progress.value=Math.min(total,4999);if(!physical){message.textContent=strings.no_shipping;return}if(currency!=='USD'){message.textContent=strings.other_currency;return}const remaining=Math.max(0,4999-total);message.textContent=remaining?strings.remaining.replace('[amount]',new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(remaining/100)):strings.qualified};
show(Number(shipping.dataset.total),shipping.dataset.currency,shipping.dataset.physical==='true');let timer;let busy=false;const refresh=()=>{clearTimeout(timer);timer=setTimeout(async()=>{if(busy)return;busy=true;try{const response=await fetch(shipping.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(response.ok){const cart=await response.json();show(cart.total_price,cart.currency,cart.items.some(item=>item.requires_shipping))}}catch{}finally{busy=false}},300)};
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,refresh);
const items=document.querySelector('cart-items');if(items){this.observer=new MutationObserver(refresh);this.observer.observe(items,{childList:true,subtree:true})}this.refreshListener=refresh;document.addEventListener('change',refresh);window.addEventListener('pageshow',refresh);
}
disconnectedCallback(){window.removeEventListener('storage',this.displayListener);if(this.refreshListener){document.removeEventListener('change',this.refreshListener);window.removeEventListener('pageshow',this.refreshListener)}if(this.unsubscribe)this.unsubscribe();if(this.observer)this.observer.disconnect()}
}
customElements.define('xi-shopping-tools',XiShoppingTools);

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
